<template>
  <div class="input-group">
    <label :for="id" class="label label--small">
      {{ label }}
    </label>
    <ValidationProvider :rules="validationRules" :name="name" v-slot="{ errors, touched, valid, invalid }">
      <input
        :type="type"
        class="text-input"
        :class="{
          'is-invalid': touched && invalid,
          'is-valid': touched && valid,
        }"
        :id="id"
        :name="name"
        :value="value"
        v-bind="$attrs"
        @input="$emit('input', $event.target.value)"
      >
      <span class="error-message">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
  import { ValidationProvider } from 'vee-validate';

  export default {
    name: 'TextInput',
    props: {
      id: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: false,
        default: 'text'
      },
      value: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      validationRules: {
        type: String,
        required: false,
        default: null
      }
    },
    components: {
      ValidationProvider
    }
  }
</script>

<style lang="scss" scoped>

  .text-input {
    display: block;
    width: 100%;
  }

  .input-group {
    margin-bottom: 1.2rem;
  }

  label {
    @include theme-gmhba {
      text-transform: uppercase;
    }
  }

  .error-message {
    color: var(--color-error);
    font-size: var(--text-size-06);
  }

  .is-invalid {
    border-bottom-color: var(--color-error);
  }

  .is-valid {
    border-bottom-color: var(--color-success);
  }

</style>



// WEBPACK FOOTER //
// src/components/global/TextInput.vue